import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Global error handler to prevent unhandled errors from breaking the app
window.addEventListener('error', (event) => {
  // Suppress WebSocket-related errors completely
  if (event.message?.includes('WebSocket') || 
      event.message?.includes('websocket') ||
      event.message?.includes('ws://') ||
      event.message?.includes('wss://') ||
      event.filename?.includes('WebSocket') ||
      event.filename?.includes('useWebSocket')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  // Allow other errors to be handled normally
  return true;
});

// Suppress unhandled promise rejections from WebSocket
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('WebSocket') ||
      event.reason?.message?.includes('websocket') ||
      event.reason?.message?.includes('ws://') ||
      event.reason?.message?.includes('wss://')) {
    event.preventDefault();
    return;
  }
});

createRoot(document.getElementById("root")!).render(<App />);
